import { Component, ComponentFactoryResolver, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsService } from '../../services/forms.service'
import { NotificationService } from '../../services/notificationService.service'
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { environment } from '../../../environments/environment'
import {
    GlobalConfig,
    ToastrService,
    ToastContainerDirective,
    ToastNoAnimation,
} from 'ngx-toastr';
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from 'ngx-loading';


import { cloneDeep } from 'lodash-es';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';


import { Observable, of } from 'rxjs';
import { startWith, map, debounceTime, switchMap } from 'rxjs/operators';
import { OverlayConfig } from '@angular/cdk/overlay';
import { MatOptionSelectionChange } from '@angular/material/core';
import { HttpClient } from '@angular/common/http';

interface Option {
    text: string;
    id: string;
}

// Import normalizr functions
// import { normalize, schema } from 'normalizr';
import { faLessThanEqual } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-registratura-online',
    templateUrl: './registratura-online.component.html',
    styleUrls: ['./registratura-online.component.css']
})
export class RegistraturaOnlineComponent implements OnInit {

    myControl = new FormControl();
    optionsArr!: Option[];
    filteredOptions!: Observable<Option[]>;
    selectedOptionValue: any;

    errorTitle: string = environment.customNotifications.headers.error
    errorIcon: string = environment.customNotifications.icons.error
    errorType: string = environment.customNotifications.icons.error
    successTitle: string = environment.customNotifications.headers.success
    successIcon: string = environment.customNotifications.icons.success
    successType: string = environment.customNotifications.icons.success

    @ViewChild('ngxLoading') ngxLoadingComponent: NgxLoadingComponent | undefined;
    @ViewChild('customLoadingTemplate') customLoadingTemplate: TemplateRef<any> | undefined;
    public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
    public loading = false;
    public loadingTemplate: TemplateRef<any> | undefined;

    currentSection: any;
    foundAddressId: any;
    currentCategory: any;
    sectionChosen: any;
    tipPersoana: any;
    tipCategorie: any;
    forms: any;
    notice: any;
    faqList: any;
    data: any;
    formStructure: any;
    user: any = {};
    filesArr: any = {};
    maxFilesNo = 3;
    terms: any = {
        declar_propria_rasp: false,
        declar_acte: false,
        terms: false
    }

    options = {
        progressBar: true,
        preventDuplicates: true,
        closeButton: true,
        iconClasses: {
            success: 'toast-success',
            error: 'toast-error',
            warning: 'toast-warning',
            info: 'toast-info',
        },
    };

    // options!: GlobalConfig;
    filter!: GlobalConfig;
    uploading: any = {};

    private lastInserted: number[] = [];
    identificareForm!: FormGroup;
    informatiiForm!: FormGroup;
    extraInformatiiForm!: FormGroup;
    fisiereForm!: FormGroup;
    extraInformatiiLength = 0;

    isFromExternalSite = false;

    constructor(
        private service: FormsService,
        private fb: FormBuilder,
        private notificationService: NotificationService,
        private toastr: ToastrService,
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
    ) {
        this.tipPersoana = null;
        this.tipCategorie = null;
        this.sectionChosen = null;

        // this.filteredOptions = this.myControl.valueChanges.pipe(
        // 	startWith(''),
        // 	map(value => this._filter(value))
        // );

        // this.filteredOptions = this.myControl.valueChanges.pipe(
        // 	startWith(''),
        // 	map(value => of(this._filter(value)))  // Wrap the returned array in an Observable
        // );

        // this.filteredOptions = this.myControl.valueChanges.pipe(
        // 	startWith(''),
        // 	switchMap(value => this._filter(value))  // Use switchMap to handle Observable returned by _filter
        // );

        this.filteredOptions = this.myControl.valueChanges.pipe(
            debounceTime(300), // wait for a pause in typing
            startWith(''),
            switchMap(value => this._filter(value || ''))
        );

        // this.filteredOptions = this.myControl.valueChanges.pipe(
        // 	startWith(''),
        // 	map(value => (typeof value === 'string' ? value : value.name)),
        // 	map(name => (name ? this._filter(name) : this.optionsArr.slice())),
        // );

    }

    private _filter(value: string): Observable<any[]> {
        // const filterValue = value.toLowerCase();
        const filterValue = value // don't know why, but lowercase seems to not work

        if (value === '' || !value) {
            // If the value is empty, clear the form field
            this.identificareForm.get('id_address')?.patchValue('');
        }

        return this.http.get<any[]>('https://app.nanoterra.ro/harti/ajax/search', {
            params: {
                oras: 'sector4_remote',
                search_after: 'cladiri',
                select2: '1',
                query: filterValue
            }
        }).pipe(
            map((response: any) => response.suggestions || [])
        );
    }

    // private _filter(value: string | null): Observable<Option[]> {
    // 	let options: any = [];
    // 	if (value?.trim()) {
    // 		const filterValue = this.normalizeString(value);
    // 		options = this.optionsArr.filter(option =>
    // 			this.normalizeString(option.label).includes(filterValue)
    // 		);
    // 	}
    // 	return of(options); // Wraps the array in an Observable
    // }
    displayFn(option: Option): string {
        return option && option.text ? option.text : '';
    }

    // private _filter(name: string): Option[] {
    // 	const filterValue = name.toLowerCase();

    // 	return this.optionsArr.filter(option => option.label.toLowerCase().includes(filterValue));
    // }

    // private _filter(value: string): Observable<Option[]> {
    // 	console.log(value, 'here is my trim?')
    // 	if (typeof value != 'undefined' && value != '') {
    // 		const filterValue = this.normalizeString(value);
    // 		return of(this.optionsArr.filter(option =>
    // 			this.normalizeString(option.label).includes(filterValue)
    // 		));
    // 	}
    // 	return of([]);  // Return an Observable directly
    // }

    // private normalizeString(str: string | null | undefined): string {
    // 	if (str == null) {  // This checks for both null and undefined
    // 		return '';
    // 	}
    // 	return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    // }

    // private normalizeString(str: string | null | undefined): string {
    private normalizeString(str: any = null): string {
        if (str == null || str == '') {  // This checks for both null and undefined
            return '';
        }
        // Check if the normalize function is available on the String prototype
        if (typeof str.normalize !== "function") {
            // If normalize is not available, return the lowercase version of the string
            // This is less ideal as it doesn't remove accents or diacritical marks
            return str.toLowerCase();
        }
        // If normalize is available, use it to decompose characters and remove diacritical marks
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    }


    ngOnInit(): void {
        this.route.queryParams.subscribe(async params => {
            // Scenario 1: Link-uri de la mobilitate cu parametrii specifici
            if (params['tip_persoana'] && params['categorie']) {
                this.tipPersoana = params['tip_persoana'].toString();
                this.tipCategorie = params['categorie'].toString();
                console.log('Link de la mobilitate - Tip persoană:', this.tipPersoana, 'Categorie:', this.tipCategorie);

                // Dacă avem și section specificat, deschide direct formularul
                if (params['section']) {
                    console.log('Section preluat din URL:', params['section']);

                    // Obține forms pentru categoria setată
                    console.log(this.tipCategorie)
                    const success = await this.getForms();

                    if (success && this.forms && Array.isArray(this.forms)) {
                        // Găsește form-ul care corespunde cu section-ul
                        const sectionId = params['section'];
                        const selectedForm = this.forms.find((form: any) =>
                            form.id.toString() === sectionId.toString()
                        );

                        if (selectedForm) {
                            this.sectionChosen = selectedForm.id;
                            console.log('Form selectat automat:', selectedForm.name);
                            console.log('Form selectat automat:', selectedForm.id);
                            this.getFormStructure();
                        } else {
                            console.warn(`Form cu section=${sectionId} nu a fost găsit!`);
                        }
                    } else {
                        console.error("Forms data is not available.");
                    }
                } else {
                    // Dacă avem doar tip_persoana și categorie, obține forms pentru afișarea listei
                    await this.getForms();
                }

                // Curăță URL-ul de parametrii
                this.router.navigate([], {
                    queryParams: {},
                    queryParamsHandling: '',
                    replaceUrl: true
                });

            }
            // Scenario 2: Fluxul existent cu source=mobilitate
            else if (params['source'] === 'mobilitate') {
                this.isFromExternalSite = true;

                this.router.navigate([], {
                    queryParams: {},
                    queryParamsHandling: 'merge',
                    replaceUrl: true
                });
            }
            // Scenario 3: Fluxul normal - fără parametri speciali
            else {
                this.isFromExternalSite = false;
            }
        });
    }

    async chooseTipPersoana(value: string) {
        this.tipPersoana = value;

        if (this.isFromExternalSite === true) {
            if (!this.tipCategorie) {
                this.tipCategorie = '7';
                console.log(this.tipCategorie)
            }

            // Wait for getForms() to complete before proceeding
            const success = await this.getForms();

            if (success && this.forms && Array.isArray(this.forms)) {
                // Find the form where name matches
                const selectedForm = this.forms.find(
                    (form: any) => form.name === "Solicitare tarif anual parcare publică stradală"
                );

                if (selectedForm) {
                    this.sectionChosen = selectedForm.id.toString(); // Set the ID dynamically
                    this.getFormStructure();
                } else {
                    console.warn("Form not found!");
                }
            } else {
                console.error("Forms data is not available.");
            }
        }
    }

    chooseTipCategorie(value: string) {
        this.tipCategorie = value;
    }

    chooseSection(value: string) {
        this.sectionChosen = value;
    }

    // isValueValid(item: { name: any; values: any[]; }): any {
    // 	const value = this.myControl.get(item.name).value;
    // 	console.log (item.values.some(val => val.label.toLowerCase() === value.toLowerCase()));
    // 	return item.values.some(val => val.label.toLowerCase() === value.toLowerCase());
    //   }


    // getValidFieldFormOne(index: any) {
    // 	return this.identificareForm.get(index);
    // }

    // getValidFieldFormTwo(index: any) {
    // 	return this.informatiiForm.get(index);
    // }

    resetAll() {
        this.tipPersoana = null;
        this.forms = null;
        this.sectionChosen = null;
        this.notice = null;
        this.faqList = null;
        this.terms = {
            declar_propria_rasp: false,
            declar_acte: false,
            terms: false
        }
        this.myControl.setValue('');
        this.resetObjectFields()
    }
    resetForm() {
        this.sectionChosen = null;
        this.notice = null;
        this.faqList = null;
        this.terms = {
            declar_propria_rasp: false,
            declar_acte: false,
            terms: false
        }
        this.myControl.setValue('');
        this.resetObjectFields()
    }

    resetObjectFields(): void {
        var self = this
        Object.keys(this.filesArr).forEach(key => {
            self.filesArr[key] = [];
        });
    }


    onOptionSelected(event: any, formName: string): void {
        console.log(event.option.value, 'is my value corect?')
        this.selectedOptionValue = event.option.value;
        // const optionId = this.optionsArr.find(opt => opt.text === this.selectedOptionValue);
        const optionId = event.option.value.id;
        console.log(optionId, 'my option chosen')
        const formGroup = (this as any)[formName] as FormGroup;
        formGroup.get('id_address')?.patchValue(optionId);
    }


    onInputBlur() {
        console.log('blur me')
        console.log(this.myControl.value, 'my value is here?')
        console.log(this.selectedOptionValue, 'selected ? ')
        if (this.myControl.value != this.selectedOptionValue) {
            this.myControl.setValue('');
        }
    }

    clickFileItem(itemKey: string) {
        let element: HTMLElement = document.getElementById(itemKey) as HTMLElement;
        element.click();
    }

    removeFile(key: string | number, index: any) {
        this.filesArr[key].splice(index, 1);

        const fileInput = document.getElementById('file_' + key) as HTMLInputElement;

        if (fileInput) {
            fileInput.value = '';
        }
    }

    checkForInfo(type: number): boolean {
        if (this.formStructure && this.formStructure.form.info.length > 0) {
            for (const item of this.formStructure.form.info) {
                if (item.type_id === type) {
                    return true;
                }
            }
        }

        return false;
    }



    // async getForms() {
    //     this.loading = true;
    //     this.service.getForms(this.tipCategorie)
    //         .then(async (response) => {
    //             if (response.status_code === 200 && response.data) {
    //                 // everything ok now, we wrap it up now
    //                 this.forms = response.data.forms
    //                 this.notice = response.data.category_notice
    //                 this.currentCategory = response.data.category

    //                 // console.log(this.notice.length);
    //                 this.loading = false;
    //                 return false;
    //             } else if (response.status_code === 400 && response.errors) {
    //                 let errorMsg = response.errors.file[0]
    //                 await this.notificationService.warningSwal(
    //                     this.errorTitle, errorMsg, this.errorIcon
    //                 );
    //                 return false;
    //             } else {
    //                 let errorMsg = "Ne pare rau, dar am intampinat o problema in rezolvarea cererii dumneavoastra. Va rugam sa reincercati mai tarziu."
    //                 await this.notificationService.warningSwal(
    //                     this.errorTitle, errorMsg, this.errorIcon
    //                 );
    //                 return false;
    //             }
    //         })
    //         .catch(async (error) => {
    //             console.error(error);
    //             await this.notificationService.warningSwal(
    //                 this.errorTitle, error.message, this.errorIcon
    //             );
    //             return false;
    //         });
    // }

    async getForms(): Promise<boolean> {
        this.loading = true;
        try {
            const response = await this.service.getForms(this.tipCategorie); // ✅ Waits for the API call

            if (response.status_code === 200 && response.data) {
                this.forms = response.data.forms;
                this.notice = response.data.category_notice;
                this.currentCategory = response.data.category;
                this.loading = false;
                return true;
            }

            let errorMsg = response.status_code === 400 && response.errors
                ? response.errors.file[0]
                : "Ne pare rau, dar am intampinat o problema in rezolvarea cererii dumneavoastra. Va rugam sa reincercati mai tarziu.";

            await this.notificationService.warningSwal(this.errorTitle, errorMsg, this.errorIcon);
            this.loading = false;
            return false;

        } catch (error: any) {
            console.error(error);
            await this.notificationService.warningSwal(this.errorTitle, error.message, this.errorIcon);
            this.loading = false;
            return false;
        }
    }


    async getFormStructure() {
        this.loading = true;
        this.service.renderForm(this.sectionChosen, this.tipPersoana, this.tipCategorie)
            .then(async (response) => {
                if (response.status_code === 200 && response.data) {

                    this.currentSection = response.data.form_details.name;
                    this.formStructure = response.data.form_structure;
                    this.notice = response.data.notice;
                    this.faqList = response.data.faq

                    this.optionsArr = response.data.addresses

                    this.prepareFormStructure(this.formStructure);

                    // check for info rules
                    // const hasInfoIdentificare = this.formStructure.form.info.some((item: {
                    // 	type_id: string; name: string; 
                    // }) => item.type_id == '1');
                    // const hasInfoInformatii = this.formStructure.form.info.some((item: {
                    // 	type_id: string; name: string; 
                    // }) => item.type_id == '2');
                    // const hasInfoInformatiiExtra = this.formStructure.form.info.some((item: {
                    // 	type_id: string; name: string; 
                    // }) => item.type_id == '4');
                    // const hasInfoDocumente = this.formStructure.form.info.some((item: {
                    // 	type_id: string; name: string; 
                    // }) => item.type_id == '3');

                    this.loading = false;
                    return false;
                } else if (response.status_code === 400 && response.errors) {
                    let errorMsg = response.errors.file[0]
                    await this.notificationService.warningSwal(
                        this.errorTitle, errorMsg, this.errorIcon
                    );
                    return false;
                } else {
                    let errorMsg = "Ne pare rau, dar am intampinat o problema in rezolvarea cererii dumneavoastra. Va rugam sa reincercati mai tarziu."
                    await this.notificationService.warningSwal(
                        this.errorTitle, errorMsg, this.errorIcon
                    );
                    return false;
                }
            })
            .catch(async (error) => {
                console.error(error);
                await this.notificationService.warningSwal(
                    this.errorTitle, error.message, this.errorIcon
                );
                return false;
            });
    }



    async prepareFormStructure(data: any = null) {
        var self = this
        if (typeof data == 'undefined' || data == null) {
            // naspa
        } else {
            let formData = data.form
            let infoData = data.info

            // identificare
            let validationFields;
            let pushValidationID = 1
            let val = {}

            interface IdentificareForm {
                [key: string]: FormControl;
            }

            let identificareToPush: IdentificareForm = {};
            await formData.identificare.forEach(async (item: { required: any; name: string | number; }) => {
                validationFields = []
                pushValidationID = 1

                if (item.required)
                    validationFields.push(Validators.required)

                val = { value: '', disabled: false }

                if (validationFields.length > 0 && pushValidationID) {
                    identificareToPush[item.name] = new FormControl(val, Validators.compose(validationFields));
                } else {
                    identificareToPush[item.name] = new FormControl(val);
                }

            })


            let informatiiToPush: { [key: string]: any } = {};

            await formData.informatii.forEach(async (item: { required: any; name: string | number; }) => {
                validationFields = []
                pushValidationID = 1

                if (item.required)
                    validationFields.push(Validators.required)

                val = { value: '', disabled: false }

                if (validationFields.length > 0 && pushValidationID) {
                    informatiiToPush[item.name] = new FormControl(val, Validators.compose(validationFields))
                } else {
                    informatiiToPush[item.name] = new FormControl(val)
                }
            })


            // informatii extra
            let extraInformatiiToPush: { [key: string]: any } = {};
            // console.log(formData.extra + 'aici form data');
            await formData.extra.forEach(async (item: { required: any; name: string | number; }) => {
                validationFields = []
                pushValidationID = 1

                if (item.required) {
                    validationFields.push(Validators.required)
                }

                val = { value: '', disabled: false }

                if (validationFields.length > 0 && pushValidationID) {
                    extraInformatiiToPush[item.name] = new FormControl(val, Validators.compose(validationFields))
                } else {
                    extraInformatiiToPush[item.name] = new FormControl(val)
                }
            })

            // fisiere
            let fisiereToPush: { [key: string]: any } = {};
            await formData.fisiere.forEach(async (item: { required: any; name: string | number; }) => {
                validationFields = []
                pushValidationID = 0;

                if (item.required) {
                    validationFields.push(Validators.required)
                    pushValidationID = 1;
                }

                if (validationFields.length > 0 && pushValidationID)
                    fisiereToPush[item.name] = new FormControl(val, Validators.compose(validationFields))
                else
                    fisiereToPush[item.name] = new FormControl(val)

                // we prepare an array for registratura
                self.filesArr[item.name] = []
            })

            self.identificareForm = new FormGroup(identificareToPush);
            self.informatiiForm = new FormGroup(informatiiToPush)
            self.extraInformatiiForm = new FormGroup(extraInformatiiToPush)
            self.fisiereForm = new FormGroup(fisiereToPush)

            // const formValues = self.extraInformatiiForm.value;
            self.extraInformatiiLength = Object.keys(self.extraInformatiiForm.value).length;

            setTimeout(() => {
                console.log(self.informatiiForm.value, 'form here')
            }, 500)

        }
    }

    upload(target: any, key: any) {
        const selectedFile: File = target.files[0];
        const formData = new FormData();
        formData.append('file', selectedFile, selectedFile.name);
        this.uploading[key] = true;
        return this.service.fileUpload(formData)
            .then(async (response) => {
                if (response.status_code === 200 && response.data) {
                    this.filesArr[key].push(response.data);
                    let objToPatch: any = {};
                    objToPatch[key] = this.filesArr[key];
                    this.fisiereForm.patchValue(objToPatch);
                    this.uploading[key] = false;
                    let obj = {
                        title: this.successTitle,
                        message: 'Fisierul dvs a fost adaugat cu succes.',
                        type: this.successIcon
                    }
                    this.openToast(obj)
                    return false;
                } else if (response.status_code === 400 && response.errors) {
                    let errorMsg = response.errors.file[0]
                    await this.notificationService.warningSwal(
                        this.errorTitle, errorMsg, this.errorIcon
                    );
                    this.uploading[key] = false;
                    return false;
                } else {
                    let errorMsg = "Ne pare rau, dar am intampinat o problema in rezolvarea cererii dumneavoastra. Va rugam sa reincercati mai tarziu."
                    await this.notificationService.warningSwal(
                        this.errorTitle, errorMsg, this.errorIcon
                    );
                    this.uploading[key] = false;
                    return false;
                }
            })
            .catch(async (error) => {
                console.error(error);
                await this.notificationService.warningSwal(
                    this.errorTitle, error.message, this.errorIcon
                );
                this.uploading[key] = false;
                return false;
            });
    }

    checkFormValidity() {
        const invalidFields: any = [];
        Object.keys(this.identificareForm.controls).forEach(key => {
            const control = this.identificareForm.get(key);
            if (control && !control.valid) {
                invalidFields.push(key);
            }
        });

        console.log('Invalid fields:', invalidFields);
    }

    async submit() {
        console.log(this.myControl)
        console.log('my control above')

        const result = await Swal.fire({
            title: 'Atenție!',
            text: 'Vă rugăm să confirmați că datele introduse sunt conform documentelor solicitantului (CNP/CUI, adresă de domiciliu/reședință/sediu social/punct de lucru), telefon și adresă de email.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Închide',
            reverseButtons: true
        });

        if (!result.isConfirmed) {
            return false;
        }

        if (!this.identificareForm.valid) {
            this.checkFormValidity();
            if (this.identificareForm.get('id_address')?.hasError('required')) {
                await this.notificationService.warningSwal(this.errorTitle, 'Vă rugăm să alegeți o adresă din listă.', this.errorIcon);
                return false;
            }
            await this.notificationService.warningSwal(this.errorTitle, 'Completați toate câmpurile obligatorii din secțiunea IDENTIFICARE', this.errorIcon);
            return false
        } else if (!this.informatiiForm.valid) {
            await this.notificationService.warningSwal(this.errorTitle, 'Completați toate câmpurile obligatorii din secțiunea INFORMATII', this.errorIcon);
            return false
        } else if (!this.fisiereForm.valid) {
            await this.notificationService.warningSwal(this.errorTitle, 'Vă rugăm sa adâugați toate fișierele obligatorii', this.errorIcon);
            return false
        } else if (!this.extraInformatiiForm.valid) {
            await this.notificationService.warningSwal(this.errorTitle, 'Completați toate câmpurile obligatorii din secțiunea INFORMATII EXTRA', this.errorIcon);
            return false
        }
        else {
            console.log('all forms good');

            const identificareData = this.identificareForm.value;
            const informatiiData = this.informatiiForm.value;
            const extraInformatiiData = this.extraInformatiiForm.value;
            // const fisiereData = this.fisiereForm.value;
            const fisiereData = this.filesArr;

            // const data = Object.assign({},
            // 	identificareData,
            // 	informatiiData,
            // 	extraInformatiiData,
            // 	this.terms,
            // 	{
            // 		section: this.sectionChosen,
            // 		persoana: this.tipPersoana,
            // 		category: this.currentCategory,
            // 		files: this.filesArr,
            // 	},
            // 	fisiereData
            // );

            // const files = Object.assign({}, fisiereData);
            const files = fisiereData;
            // const data = Object.assign(this.values, { subsemnatul: this.subsemnatul }, { idForm: this.sectionId })


            const values = Object.assign({},
                identificareData,
                informatiiData,
                extraInformatiiData,
                this.terms,
            );

            const info = Object.assign({}, {
                sectionId: this.sectionChosen,
                section: this.currentSection,
                categoryId: this.tipCategorie,
                persoana: this.tipPersoana,
                category: this.currentCategory
            }
            );

            const data = Object.assign({ data: values }, { file: files }, { info: info })

            // const data = { data: values, files: files };

            // console.log(data, 'data sent');
            // return false

            return this.service.storeRegistratura(data)
                .then(async (response) => {
                    console.log(response);
                    if (response.status_code === 200 && response.data) {
                        // check here if we have success
                        // success
                        console.log('success store')
                        // let obj = {
                        // 	title: this.successTitle,
                        // 	message: 'Formular adaugat cu success.',
                        // 	type: this.successIcon
                        // }

                        // de reactivat!!!
                        await this.notificationService.warningSwal('Succes!', `${response.data} <br>Vă rugăm să verificați adresa de email, atât în Inbox cât și în Spam, pentru confirmarea înregistrării solicitării dumneavoastră, având în vedere faptul că pe aceeași adresă de mail veți primi mesajele de completare a documentelor, atunci când este cazul sau soluționarea cererii dumneavoastră!`, this.successIcon, true);
                        this.resetAll()
                        // end to reactivate
                        // this.openToast(obj)
                        // this.myControl.reset();
                        // this.getFormStructure();

                        return false
                    } else if (response.status_code === 400 && response.message) {
                        let errorMsg = response.message
                        await this.notificationService.warningSwal(
                            this.errorTitle, errorMsg, this.errorIcon
                        );
                        return false;
                    } else {
                        let errorMsg = "Ne pare rau, dar am intampinat o problema in rezolvarea cererii dumneavoastra. Va rugam sa reincercati mai tarziu."
                        await this.notificationService.warningSwal(
                            this.errorTitle, errorMsg, this.errorIcon
                        );
                        return false;
                    }
                })
                .catch(async (error) => {
                    console.error(error);
                    await this.notificationService.warningSwal(
                        this.errorTitle, error.message, this.errorIcon
                    );
                    return false;
                })
        }
    }

    openToast(object: { type: any; message: any; title: any; }) {

        const { type, message, title } = object

        this.options.progressBar = true
        this.options.preventDuplicates = true
        this.options.closeButton = true

        // Clone current config so it doesn't change when ngModel updates
        const opt = cloneDeep(this.options);
        const inserted = this.toastr.show(
            message,
            title,
            opt,
            this.options.iconClasses[type]
        );
        if (inserted) {
            this.lastInserted.push(inserted.toastId);
        }
        return inserted;
    }



    // ============================================
    // old functions, park them please
    // ============================================

    // private normalizeString(str: any): string {
    // 	console.log('normalizeString input:', str, 'Type:', typeof str);

    // 	if (typeof str !== 'string') {
    // 		if (str === null || str === undefined) {
    // 			return '';
    // 		}
    // 		str = String(str);
    // 	}

    // 	console.log('String to normalize:', str);  // Check the string before normalization

    // 	if (typeof str.normalize === "function") {
    // 		return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    // 	}
    // 	return str.toLowerCase();
    // }


    // private _filter(value: string): Option[] {

    // 	if (value?.trim()) {  // Checks for non-empty, non-null, and non-undefined strings
    // 		const filterValue = value.toLowerCase();
    // 		return this.optionsArr.filter(option => option.label?.toLowerCase().includes(filterValue));
    // 	} else {
    // 		return [];  // Clear options if input is empty or null
    // 	}

    // 	// if (value != null) {
    // 	// 	const filterValue = value.toLowerCase();
    // 	// 	console.log(filterValue, 'check on this?')
    // 	// 	return this.optionsArr.filter(option => option.label.toLowerCase().includes(filterValue));
    // 	// } else {
    // 	// 	return [];
    // 	// }
    // }

}
